"use client"
import React from 'react'

export default function ComingSoonButtonClient({
  className = '',
  children,
  label,
}: {
  className?: string
  children?: React.ReactNode
  label?: string
}) {
  const text = label || 'Coming soon'
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event('open-coming-soon'))}
      className={className}
    >
      {children ?? text}
    </button>
  )
}

